module.exports = __webpack_public_path__ + "img/pm.1173d035.jpg";